export const getBrowser = (): {
  browser: 'edge' | 'ie' | 'firefox' | 'chrome' | 'safari' | 'opera' | null
  version: string
} => {
  const ua = navigator.userAgent.toLowerCase()

  if (ua.match(/edge\/([\d.]+)/)) {
    return {
      browser: 'edge',
      version: ua.match(/edge\/([\d.]+)/)?.[1] || '0',
    }
  }

  if (ua.match(/rv:([\d.]+)\) like gecko/)) {
    return {
      browser: 'ie',
      version: ua.match(/rv:([\d.]+)\) like gecko/)?.[1] || '0',
    }
  }

  if (ua.match(/msie ([\d.]+)/)) {
    return {
      browser: 'ie',
      version: ua.match(/msie ([\d.]+)/)?.[1] || '0',
    }
  }

  if (ua.match(/firefox\/([\d.]+)/)) {
    return {
      browser: 'firefox',
      version: ua.match(/firefox\/([\d.]+)/)?.[1] || '0',
    }
  }

  if (ua.match(/chrome\/([\d.]+)/)) {
    return {
      browser: 'chrome',
      version: ua.match(/chrome\/([\d.]+)/)?.[1] || '0',
    }
  }

  if (ua.match(/opera.([\d.]+)/)) {
    return {
      browser: 'opera',
      version: ua.match(/opera.([\d.]+)/)?.[1] || '0',
    }
  }

  if (ua.match(/version\/([\d.]+).*safari/)) {
    return {
      browser: 'safari',
      version: ua.match(/version\/([\d.]+).*safari/)?.[1] || '0',
    }
  }

  return { browser: null, version: '0' }
}

// Webp as watershed https://caniuse.com/webp
export const isLowerBrowserForWebP = () => {
  const browserInfo = getBrowser()
  switch (browserInfo.browser) {
    case 'chrome':
      return {
        browser: 'Chrome',
        result: Number(browserInfo.version.split('.')[0]) < 32,
        url: 'https://www.google.com/chrome/',
      }
    case 'edge':
      return {
        browser: 'Edge',
        result: Number(browserInfo.version.split('.')[0]) < 18,
        url: 'https://www.microsoft.com/en-us/edge/download',
      }
    case 'firefox':
      return {
        browser: 'Firefox',
        result: Number(browserInfo.version.split('.')[0]) < 65,
        url: 'https://www.mozilla.org/en-US/firefox/',
      }
    case 'safari':
      return {
        browser: 'Safari',
        result: Number(browserInfo.version.split('.')[0]) < 16,
        url: 'https://support.apple.com/downloads/safari/',
      }
    case 'opera':
      return {
        browser: 'Opera',
        result: Number(browserInfo.version.split('.')[0]) < 19,
        url: 'https://www.opera.com/',
      }
    case 'ie':
      return { browser: 'IE', result: false, url: 'https://www.microsoft.com/en-us/edge/download' }
    default:
      return { browser: '', result: false, url: '' }
  }
}
